import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './ButtonSkeleton.module.scss.js';

var ButtonSkeleton = function (_a) {
    var style = _a.style, className = _a.className;
    return (jsx("div", { className: clsx(className, styles.button), style: style }));
};

export { ButtonSkeleton };
